// extracted by css-extract-rspack-plugin
var _1 = "od8q2";
var _2 = "Fmuck";
export { _1 as "redDark", _2 as "snooze" }
